import * as React from 'react';
export var defaultCardSize = 'large';
export var CardContext = React.createContext({
    size: defaultCardSize,
});
export var useCardContext = function () { return React.useContext(CardContext); };
